import EventListener from '@/services/EventListener/EventListener'
import { GlobalEventsMap } from './IGlobalEvents'

class GlobalEvents extends EventListener<GlobalEventsMap> {
}

const globalEvents = new GlobalEvents()
export default globalEvents
